// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-list-modal {
  background: var(--bg-primary);
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid var(--border-color);
  animation: modal-pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.list-form {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.list-input {
  width: 100%;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.2s;
}

.list-input:focus {
  outline: none;
  border-color: var(--accent-color);
}

.list-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.list-cancel-btn {
  padding: 8px 24px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  transition: all 0.2s;
}

.list-cancel-btn:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.list-submit-btn {
  padding: 8px 24px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background: var(--accent-primary);
  color: #ffffff;
  border: none;
  transition: background 0.2s;
}

.list-submit-btn:hover:not(:disabled) {
  background: var(--accent-hover);
}

.list-submit-btn:disabled,
.list-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .create-list-modal {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    border-radius: 0;
    border: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateListModal/CreateListModal.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;EACrC,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".create-list-modal {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  border: 1px solid var(--border-color);\n  animation: modal-pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.list-form {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.list-input {\n  width: 100%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border-color 0.2s;\n}\n\n.list-input:focus {\n  outline: none;\n  border-color: var(--accent-color);\n}\n\n.list-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.list-cancel-btn {\n  padding: 8px 24px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  transition: all 0.2s;\n}\n\n.list-cancel-btn:hover:not(:disabled) {\n  background: var(--bg-hover);\n  color: var(--text-primary);\n}\n\n.list-submit-btn {\n  padding: 8px 24px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  background: var(--accent-primary);\n  color: #ffffff;\n  border: none;\n  transition: background 0.2s;\n}\n\n.list-submit-btn:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.list-submit-btn:disabled,\n.list-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 600px) {\n  .create-list-modal {\n    width: 100%;\n    height: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
